

import logoLight from "@/images/logo.png"
import logoDark from "@/images/logo2.png"
import sliderOne01 from "@/images/slider/1_1.jpg"
import sliderOne02 from "@/images/slider/1_2.jpg"
import sliderTwo01 from "@/images/slider/2_1.jpg"
import sliderTwo02 from "@/images/slider/2_2.jpg"
import sliderTwo03 from "@/images/slider/2_3.jpg"
import sliderThree01 from "@/images/slider/3_1.jpg"
import sliderThree02 from "@/images/slider/3_2.jpg"
import blogImage1 from "@/images/blog/1.jpg"
import blogImage2 from "@/images/blog/2.jpg"
import blogImage3 from "@/images/blog/3.jpg"
import blogImage4 from "@/images/blog/4.jpg"
import blogImage5 from "@/images/blog/5.jpg"
import blogImage6 from "@/images/blog/6.jpg"
import blogImageTwo1 from "@/images/blog/14.jpg"
import blogImageTwo2 from "@/images/blog/15.jpg"
import blogS1 from "@/images/blog/11.jpg"
import blogS2 from "@/images/blog/12.jpg"
import blogS3 from "@/images/blog/13.jpg"
import commentImage1 from "@/images/blog/9.jpg"
import commentImage2 from "@/images/blog/10.jpg"
import portfolio01 from "@/images/portfolio/1.jpg"
import portfolio02 from "@/images/portfolio/2.jpg"
import portfolio03 from "@/images/portfolio/3.jpg"
import portfolio04 from "@/images/portfolio/4.jpg"
import portfolio05 from "@/images/portfolio/5.jpg"
import portfolio06 from "@/images/portfolio/6.jpg"
import portfolioD01 from "@/images/portfolio/7.jpg"
import portfolioD02 from "@/images/portfolio/8.jpg"
import serviceOne01 from "@/images/home_1/6.jpg"
import serviceOne02 from "@/images/home_1/7.jpg"
import serviceOne03 from "@/images/home_1/8.jpg"
import trustClient01 from "@/images/home_1/4.jpg"
import ClientCarousel01 from "@/images/client/1.png"
import ClientCarousel02 from "@/images/client/2.png"
import ClientCarousel03 from "@/images/client/3.png"
import ClientCarousel04 from "@/images/client/4.png"
import ClientCarousel05 from "@/images/client/5.png"
import aboutOne01 from "@/images/about/1.jpg"
import aboutOne02 from "@/images/about/2.jpg"
import team01 from "@/images/team/1.jpg"
import team02 from "@/images/team/2.jpg"
import team03 from "@/images/team/3.jpg"
import team04 from "@/images/team/4.jpg"
import team05 from "@/images/team/5.jpg"
import video01 from "@/images/about/3.jpg"
import testimonial01 from "@/images/home_1/t1.jpg"
import testimonial02 from "@/images/home_1/t2.jpg"
import testimonial03 from "@/images/home_1/t3.jpg"
import featureTab01 from "@/images/home_1/c1.jpg"
import featureTab02 from "@/images/home_1/c2.jpg"
import featureTab03 from "@/images/home_1/c3.jpg"
import video02 from "@/images/home_1/3.jpg"
import aboutTwo01 from "@/images/home_1/2.jpg"
import aboutTwo02 from "@/images/home_1/1.jpg"
import featureTwo01 from "@/images/home_1/5.jpg"

import menuArrowDown from '../assets/images/lp/menu-arrow-down.svg'

export const LogoImage = {
  light: logoLight,
  dark: logoDark,
};

export const NavLinks = [
  {
    name: "SOBRE NÓS",
    url: "/#sobre",
  },
  {
    name: `EXTRACURRICULARES`,
    icon: menuArrowDown,
    subItems: [
      {
        name: "COMPANHIA DE TEATRO",
        url: "/atividades-adicionais#CIA-teatro",
      },
      {
        name: "COLABORATIVE FABLAB",
        url: "/atividades-adicionais#FABLAB",
      },
      {
        name: "STEAM",
        url: "/atividades-adicionais#STRIKE",
      },
    ],
  },
  {
    name: "UNIDADES",
    icon: menuArrowDown,
    subItems: [
      {
        name: "Bert Kids",
        url: "/bert-kids",
      },
      {
        name: "Bert",
        url: "/bert",
      },
    ],
  },
  {
    name: "PAIS",
    url: "/essencial-para-os-pais",
  },
  // {
  //   name: "BLOG",
  //   url: "/",
  // },
  {
    name: "CONTATO",
    url: "/#contatos",
  },
];



export const SliderOneData = [
  {
    image: sliderOne01,
    subTitle: "Lorem ipsum dolor sit amet",
    title: "LOREM IPSUM \n DOLOR SIT.",
    button: {
      label: "LOREM IPSUM",
      url: "/about",
    },
  },
  {
    image: sliderOne02,
    subTitle: "Lorem ipsum dolor sit amet",
    title: "LOREM IPSUM \n DOLOR SIT.",
    button: {
      label: "LOREM IPSUM",
      url: "/about",
    },
  },
];


export const SliderTwoData = [
  {
    image: "https://player.vimeo.com/video/844194146?h=e62c170602&api=1&background=1&autoplay=1&loop=1&autopause=0",
    title: "Seu mundo não tem limites,\n Seu currículo também não",
    subTitle: "Formação bilíngue para alcançar as melhores universidades do Brasil e do mundo",
    button: {
      label: "LOREM IPSUM",
      url: "/about",
    },
  },
  // {
  //   image: sliderTwo02,
  //   subTitle: "Lorem ipsum dolor sit amet",
  //   title: "LOREM\nIPSUM\nDOLOR.",
  //   button: {
  //     label: "LOREM IPSUM",
  //     url: "/about",
  //   },
  // },
  // {
  //   image: sliderTwo03,
  //   subTitle: "Lorem ipsum dolor sit amet",
  //   title: "LOREM\nIPSUM\nDOLOR.",
  //   button: {
  //     label: "LOREM IPSUM",
  //     url: "/about",
  //   },
  // },
];


export const SliderThreeData = [
  {
    image: sliderThree01,
    subTitle: "Lorem ipsum dolor sit amet",
    title: "SMART WEB\n DESIGN AGENCY.",
    button: {
      label: "LOREM IPSUM",
      url: "/about",
    },
  },
  {
    image: sliderThree02,
    subTitle: "Lorem ipsum dolor sit amet",
    title: "SMART WEB\n DESIGN AGENCY.",
    button: {
      label: "LOREM IPSUM",
      url: "/about",
    },
  },
];

export const ContactInfosBlock = {
  subTitle: "LOREM IPSUM",
  title: "Lorem ipsum dolor",
  description:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet \n libero in augue volutpat varius.",
};

export const ContactInfosList = [
  {
    title: "lorem",
    infos: [
      {
        name: "Lorem ipsum dolor sit",
      },
      {
        name: "lorem@ipsum.com",
      },
      {
        name: "666 888 000",
      },
    ],
  },
  {
    title: "lorem",
    infos: [
      {
        name: "Lorem ipsum dolor sit",
      },
      {
        name: "lorem@ipsum.com",
      },
      {
        name: "666 888 000",
      },
    ],
  },
  {
    title: "lorem",
    infos: [
      {
        name: "Lorem ipsum dolor sit",
      },
      {
        name: "lorem@ipsum.com",
      },
      {
        name: "666 888 000",
      },
    ],
  },
  {
    title: "lorem",
    infos: [
      {
        name: "Lorem ipsum dolor sit",
      },
      {
        name: "lorem@ipsum.com",
      },
      {
        name: "666 888 000",
      },
    ],
  },
];

export const ContactFormTitle = {
  subTitle: "Lorem ipsum dolor",
  title: "Lorem ipsum dolor sit",
  description:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet \n libero in augue volutpat varius.",
};


export const BlogData = [
  {
    title: "Lorem ipsum dolor sit amet, consectetur adipiscing",
    date: "20 nov",
    url: "/blog-single",
    image: blogImage1,
  },
  {
    title: "Lorem ipsum dolor sit amet, consectetur adipiscing",
    date: "20 nov",
    url: "/blog-single",
    image: blogImage2,
  },
  {
    title: "Lorem ipsum dolor sit amet, consectetur adipiscing",
    date: "20 nov",
    url: "/blog-single",
    image: blogImage3,
  },
  {
    title: "Lorem ipsum dolor sit amet, consectetur adipiscing",
    date: "20 nov",
    url: "/blog-single",
    image: blogImage4,
  },
  {
    title: "Lorem ipsum dolor sit amet, consectetur adipiscing",
    date: "20 nov",
    url: "/blog-single",
    image: blogImage5,
  },
  {
    title: "Lorem ipsum dolor sit amet, consectetur adipiscing",
    date: "20 nov",
    url: "/blog-single",
    image: blogImage6,
  },
];


export const BlogTwoData = [
  {
    title:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit.",
    date: "20 nov",
    url: "/blog-single",
    image: blogImageTwo1,
  },
  {
    title: "Lorem ipsum dolor sit amet, consectetur",
    date: "20 nov",
    url: "/blog-single",
    image: blogImage2,
  },
  {
    title: "Lorem ipsum dolor sit amet, consectetur",
    date: "20 nov",
    url: "/blog-single",
    image: blogImage3,
  },
  {
    title: "Lorem ipsum dolor sit amet, consectetur",
    date: "20 nov",
    url: "/blog-single",
    image: blogImage4,
  },
  {
    title: "Lorem ipsum dolor sit amet, consectetur",
    date: "20 nov",
    url: "/blog-single",
    image: blogImage5,
  },
  {
    title: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit.",
    date: "20 nov",
    url: "/blog-single",
    image: blogImageTwo2,
  },
  {
    title: "Lorem ipsum dolor sit amet,",
    date: "20 nov",
    url: "/blog-single",
    image: blogImage6,
  },
];

export const BlogHomeSection = {
  subTitle: "Lorem ipsum",
  title: "Lorem ipsum dolor",
  text:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet \n libero in augue volutpat varius.",
};


export const BlogSidebarPost = [
  {
    title: "basic rules of running web agency",
    image: blogS1,
    url: "/blog-single",
  },
  {
    title: "basic rules of running web agency",
    image: blogS2,
    url: "/blog-single",
  },
  {
    title: "basic rules of running web agency",
    image: blogS3,
    url: "/blog-single",
  },
];


export const BlogComments = [
  {
    image: commentImage1,
    name: "Lorem Ipsum",
    data: "20 Nov, 2018 - 4:00 pm",
    content:
      "Lorem Ipsum is simply dummy text of the rinting and typesetting been the industry standard dummy text ever sincer condimentum purus. In non ex at ligula fringilla lobortis et not the aliquet.",
  },
  {
    image: commentImage2,
    name: "Lorem Ipsum",
    data: "20 Nov, 2018 - 4:00 pm",
    content:
      "Lorem Ipsum is simply dummy text of the rinting and typesetting been the industry standard dummy text ever sincer condimentum purus. In non ex at ligula fringilla lobortis et not the aliquet.",
  },
];


export const PortfolioData = [
  {
    title: "LOREM IPSUM",
    categories: ["all", "graphic"],
    image: portfolio01,
    url: "/portfolio-details",
  },
  {
    title: "LOREM IPSUM",
    categories: ["all", "graphic"],
    image: portfolio02,
    url: "/portfolio-details",
  },
  {
    title: "LOREM IPSUM",
    categories: ["all", "graphic"],
    image: portfolio03,
    url: "/portfolio-details",
  },
  {
    title: "LOREM IPSUM",
    categories: ["all", "graphic"],
    image: portfolio04,
    url: "/portfolio-details",
  },
  {
    title: "LOREM IPSUM",
    categories: ["all", "graphic"],
    image: portfolio05,
    url: "/portfolio-details",
  },
  {
    title: "LOREM IPSUM",
    categories: ["all", "graphic"],
    image: portfolio06,
    url: "/portfolio-details",
  },
];

export const PortfolioFilters = [
  { name: "all" },
  { name: "graphic" },
  { name: "branding" },
  { name: "marketing" },
  { name: "logos" },
];

export const PortfolioDetailsData = {
  gallery: [{ image: portfolioD01 }, { image: portfolioD02 }],
  title: "LOREM IPSUM",
  text:
    " Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet libero in augue volutpat varius. Proin at elit ac nibh facilisis fermentum sit amet at mauris.",
  client: "Lorem ipsum",
  categories: [
    {
      name: "Lorem,",
      url: "#",
    },
    {
      name: "Lorem,",
      url: "#",
    },
  ],
  date: "8 Nov, 2018",
  socials: [
    {
      name: "Facebook",
      url: "#",
    },
    {
      name: "Twitter",
      url: "#",
    },
    {
      name: "Linkedin",
      url: "#",
    },
  ],
};

export const ServicePostData = [
  {
    title: "Lorem Ipsum",
    text:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    iconName: "mei-settings",
    url: "/service-details",
  },
  {
    title: "Lorem Ipsum",
    text:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    iconName: "mei-transfer",
    url: "/service-details",
  },
  {
    title: "Lorem Ipsum",
    text:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    iconName: "mei-pie-chart",
    url: "/service-details",
  },
];

export const ServiceHomeTwoData = {
  subTitle: "Lorem ipsum dolor sit amet",
  title: "Lorem ipsum dolor sit amet, \n consectetur adipiscing elit.",
  text:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet \n libero in augue volutpat varius.",
};

export const ServiceHomeThreeData = {
  subTitle: "Lorem ipsum dolor sit",
  title: "Lorem ipsum",
  text:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet \n libero in augue volutpat varius.",
};

export const ServicePostTwoData = {
  sectionContent: {
    title: "Lorem ipsum dolor sit amet, \n consectetur adipiscing elit.",
    subTitle: "Lorem ipsum dolor sit",
    text:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet \n libero in augue volutpat varius.",
  },
  posts: [
    {
      title: "Lorem ipsum",
      iconName: "mei-web-design",
      url: "/service-details",
    },
    {
      title: "Lorem ipsum",
      iconName: "mei-computer-graphic",
      url: "/service-details",
    },
    {
      title: "Lorem ipsum",
      iconName: "mei-development-1",
      url: "/service-details",
    },
    {
      title: "Lorem ipsum",
      iconName: "mei-development",
      url: "/service-details",
    },
    {
      title: "Lorem ipsum",
      iconName: "mei-app-development",
      url: "/service-details",
    },
  ],
};

export const ServicePostThreeData = {
  sectionContent: {
    title: "Lorem ipsum dolor",
    subTitle: "Lorem ipsum dolor",
    text:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet \n libero in augue volutpat varius.",
  },
  posts: [
    {
      title: "Lorem ipsum",
      image: serviceOne01,
      url: "/service-details",
    },
    {
      title: "Lorem ipsum",
      image: serviceOne02,
      url: "/service-details",
    },
    {
      title: "Lorem ipsum",
      image: serviceOne03,
      url: "/service-details",
    },
  ],
};

export const FunfactData = [
  {
    title: "aprovações em universidades dos EUA e China",
    countNumber: 20,
  },
  {
    title: "medalhas olímpicas",
    countNumber: 400,
  },
  {
    title: "prêmios ( 1º Lugar) no Hackathon da NASA",
    countNumber: 6,
  },
  {
    title: "campeonatos mundiais First Robotic Competition",
    countNumber: 2,
  },
  {
    title: "prêmios em competições internacionais",
    countNumber: 7,
  },
];

export const TrustClientData = {
  image: trustClient01,
  title: "Lorem ipsum dolor sit amet, consectetur adipiscing",
  text:
    "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incidi-dunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercita-tion ullamco laboris nisi ut aliquip ex ea commodo.",
  url: "/about",
};

export const ClientCarouselData = {
  sectionContent: {
    title: "Lorem ipsum dolor",
    subTitle: "Lorem ipsum",
    text:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet \n libero in augue volutpat varius.",
  },
  items: [
    {
      url: "#",
      image: ClientCarousel01,
    },
    {
      url: "#",
      image: ClientCarousel02,
    },
    {
      url: "#",
      image: ClientCarousel03,
    },
    {
      url: "#",
      image: ClientCarousel04,
    },
    {
      url: "#",
      image: ClientCarousel05,
    },
  ],
};

export const AboutOneData = {
  sectionContent: {
    title: "Lorem ipsum dolor sit amet, consectetur adipisicing elit",
    subTitle: "Lorem ipsum dolor",
  },
  gallery: [aboutOne01, aboutOne02],
  counter: {
    title: "Lorem ipsum",
    number: 1990,
  },
};

export const TeamOneData = {
  sectionContent: {
    title: "Lorem ipsum dolor",
    subTitle: "Lorem ipsum dolor dolor",
    text:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet \n libero in augue volutpat varius.",
  },
  posts: [
    {
      image: team01,
      name: "Lorem ipsum",
      designation: "Lorem ipsum",
      url: "#",
      socials: [
        {
          name: "Facebook",
          url: "#",
        },
        {
          name: "Twitter",
          url: "#",
        },
        {
          name: "Linkedin",
          url: "#",
        },
      ],
    },
    {
      image: team02,
      name: "Lorem ipsum",
      designation: "Lorem ipsum",
      url: "",
      socials: [
        {
          name: "Facebook",
          url: "#",
        },
        {
          name: "Twitter",
          url: "#",
        },
        {
          name: "Linkedin",
          url: "#",
        },
      ],
    },
    {
      image: team03,
      name: "Lorem ipsum",
      designation: "Lorem ipsum",
      url: "#",
      socials: [
        {
          name: "Facebook",
          url: "#",
        },
        {
          name: "Twitter",
          url: "#",
        },
        {
          name: "Linkedin",
          url: "#",
        },
      ],
    },
    {
      image: team04,
      name: "Lorem ipsum",
      designation: "Lorem ipsum",
      url: "#",
      socials: [
        {
          name: "Facebook",
          url: "#",
        },
        {
          name: "Twitter",
          url: "#",
        },
        {
          name: "Linkedin",
          url: "#",
        },
      ],
    },
    {
      image: team05,
      name: "Lorem ipsum",
      designation: "Lorem ipsum",
      url: "#",
      socials: [
        {
          name: "Facebook",
          url: "#",
        },
        {
          name: "Twitter",
          url: "#",
        },
        {
          name: "Linkedin",
          url: "#",
        },
      ],
    },
  ],
};

export const VideoOneData = {
  sectionContent: {
    title: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    subTitle: "Lorem ipsum dolor",
    text:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet libero in augue volutpat varius. Proin at elit ac nibh facilisis fermentum sit amet at mauris.",
  },
  video: {
    image: video01,
    ID: "y2Eqx6ys1hQ",
    title: "Watch Video",
  },
};

export const SubscribeFormData = {
  sectionContent: {
    title: "Lorem ipsum ",
    subTitle: "Lorem ipsum dolor sit amet",
  },
};

export const TestimonialsOneData = {
  sectionContent: {
    subTitle: "Lorem ipsum",
    title: "Lorem ipsum",
  },
  posts: [
    {
      name: "Lorem ipsum",
      designation: "Lorem",
      image: testimonial01,
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet libero in augue volutpat varius. Proin at elit ac nibh facilisis fermentum sit amet at mauris. Nunc sed ipsum malesuada, lacinia risus vitae, blandit ex.",
      date: "25 nov, 2018",
    },
    {
      name: "Lorem ipsum",
      designation: "Lorem",
      image: testimonial02,
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet libero in augue volutpat varius. Proin at elit ac nibh facilisis fermentum sit amet at mauris. Nunc sed ipsum malesuada, lacinia risus vitae, blandit ex.",
      date: "25 nov, 2018",
    },
    {
      name: "Lorem ipsum",
      designation: "Lorem",
      image: testimonial03,
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet libero in augue volutpat varius. Proin at elit ac nibh facilisis fermentum sit amet at mauris. Nunc sed ipsum malesuada, lacinia risus vitae, blandit ex.",
      date: "25 nov, 2018",
    },
    {
      name: "Lorem ipsum",
      designation: "Lorem",
      image: testimonial01,
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet libero in augue volutpat varius. Proin at elit ac nibh facilisis fermentum sit amet at mauris. Nunc sed ipsum malesuada, lacinia risus vitae, blandit ex.",
      date: "25 nov, 2018",
    },
    {
      name: "Lorem ipsum",
      designation: "Lorem",
      image: testimonial02,
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet libero in augue volutpat varius. Proin at elit ac nibh facilisis fermentum sit amet at mauris. Nunc sed ipsum malesuada, lacinia risus vitae, blandit ex.",
      date: "25 nov, 2018",
    },
    {
      name: "Lorem ipsum",
      designation: "Lorem",
      image: testimonial03,
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet libero in augue volutpat varius. Proin at elit ac nibh facilisis fermentum sit amet at mauris. Nunc sed ipsum malesuada, lacinia risus vitae, blandit ex.",
      date: "25 nov, 2018",
    },
    {
      name: "Lorem ipsum",
      designation: "Lorem",
      image: testimonial01,
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet libero in augue volutpat varius. Proin at elit ac nibh facilisis fermentum sit amet at mauris. Nunc sed ipsum malesuada, lacinia risus vitae, blandit ex.",
      date: "25 nov, 2018",
    },
    {
      name: "Lorem ipsum",
      designation: "Lorem",
      image: testimonial02,
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet libero in augue volutpat varius. Proin at elit ac nibh facilisis fermentum sit amet at mauris. Nunc sed ipsum malesuada, lacinia risus vitae, blandit ex.",
      date: "25 nov, 2018",
    },
    {
      name: "Lorem ipsum",
      designation: "Lorem",
      image: testimonial03,
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet libero in augue volutpat varius. Proin at elit ac nibh facilisis fermentum sit amet at mauris. Nunc sed ipsum malesuada, lacinia risus vitae, blandit ex.",
      date: "25 nov, 2018",
    },
  ],
};

export const FeatureTabData = {
  sectionContent: {
    title: "Lorem ipsum",
    subTitle: "Lorem ipsum dolor",
    text:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet \n libero in augue volutpat varius.",
  },
  posts: [
    {
      title: "Lorem ipsum",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet libero in augue volutpat varius. Proin at elit ac nibh facilisis fermentum sit amet at mauris. Nunc sed ipsum malesuada, lacinia risus vitae, blandit ex. Curabitur aliquet nec tortor eget blandit. Sed consectetur pellentesque aliquam. Fusce id malesuada sapien. Suspendisse vel vulputate libero. ",
      image: featureTab01,
      lists: [
        {
          item: "Lorem ipsum dolor sit amet, consectetur",
        },
        {
          item: "Lorem ipsum dolor sit amet, consectetur",
        },
        {
          item: "Lorem ipsum dolor sit amet, consectetur",
        },
        {
          item: "Lorem ipsum dolor sit amet, consectetur",
        },
        {
          item: "Lorem ipsum dolor sit amet, consectetur",
        },
        {
          item: "Lorem ipsum dolor sit amet, consectetur",
        },
      ],
    },
    {
      title: "Lorem ipsum",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet libero in augue volutpat varius. Proin at elit ac nibh facilisis fermentum sit amet at mauris. Nunc sed ipsum malesuada, lacinia risus vitae, blandit ex. Curabitur aliquet nec tortor eget blandit. Sed consectetur pellentesque aliquam. Fusce id malesuada sapien. Suspendisse vel vulputate libero. ",
      image: featureTab02,
      lists: [
        {
          item: "SLorem ipsum dolor sit amet, consectetur",
        },
        {
          item: "Lorem ipsum dolor sit amet, consectetur",
        },
        {
          item: "Lorem ipsum dolor sit amet, consectetur",
        },
        {
          item: "Lorem ipsum dolor sit amet, consectetur",
        },
        {
          item: "Lorem ipsum dolor sit amet, consectetur",
        },
        {
          item: "Lorem ipsum dolor sit amet, consectetur",
        },
      ],
    },
    {
      title: "Lorem ipsum dolor",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet libero in augue volutpat varius. Proin at elit ac nibh facilisis fermentum sit amet at mauris. Nunc sed ipsum malesuada, lacinia risus vitae, blandit ex. Curabitur aliquet nec tortor eget blandit. Sed consectetur pellentesque aliquam. Fusce id malesuada sapien. Suspendisse vel vulputate libero. ",
      image: featureTab03,
      lists: [
        {
          item: "SLorem ipsum dolor sit amet, consectetur",
        },
        {
          item: "Lorem ipsum dolor sit amet, consectetur",
        },
        {
          item: "Lorem ipsum dolor sit amet, consectetur",
        },
        {
          item: "Lorem ipsum dolor sit amet, consectetur",
        },
        {
          item: "Lorem ipsum dolor sit amet, consectetur",
        },
        {
          item: "Lorem ipsum dolor sit amet, consectetur",
        },
      ],
    },
  ],
};

export const ParallaxOneData = {
  iconName: "mei-team",
  title: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  specialText: "Lorem ipsum dolor sit amet.",
  text:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet \n libero in augue volutpat varius.",
};

export const PortfolioHomeData = {
  sectionContent: {
    title: "Lorem ipsum",
    subTitle: "Lorem ipsum",
    text:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet \n libero in augue volutpat varius.",
  },
};

export const VideoTwoData = {
  sectionContent: {
    title: "Lorem ipsum",
    subTitle: "Lorem ipsum dolor",
    text:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet \n libero in augue volutpat varius.",
  },
  video: {
    title: "Watch Video",
    ID: "y2Eqx6ys1hQ",
    image: video02,
  },
};


export const AboutTwoData = {
  sectionContent: {
    title: "Lorem ipsum dolor sit amet, consectetur adipiscing",
    subTitle: "Lorem ipsum dolor sit amet.",
    text:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet \n libero in augue volutpat varius. Lorem Ipsum is simply dummy text of the printing and typesetting industry has been the industry's standard dummy text ever since the 1500s.",
  },
  button: {
    label: "Lorem ipsum",
    url: "#",
  },
  gallery: [aboutTwo01, aboutTwo02],
};

export const FeatureTwoData = {
  sectionContent: {
    title: "Lorem ipsum",
    subTitle: "Lorem ipsum dolor",
    text:
      " Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet \n libero in augue volutpat varius. ",
  },
  posts: [
    {
      title: "Lorem ipsum dolor sit",
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet libero",
    },
    {
      title: "Lorem ipsum dolor sit",
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet libero",
    },
    {
      title: "Lorem ipsum dolor sit",
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sit amet libero",
    },
  ],
  image: {
    text: "Lorem ipsum dolor sit amet \n consectetur adipiscing.",
    path: featureTwo01,
  },
};

export const CallToActionTwoData = [
  {
    label: "View our Recent Work",
    url: "/portfolio",
  },
  {
    label: "Reqeust a free quote",
    url: "/contact",
  },
];
